export const courseGroups = [
  {
    id: 'a',
    titleZh: '听力',
    titleEn: 'Listening & Oral',
    image: process.env.PUBLIC_URL + '/images/listening.png',
    description: 'Develop strong listening comprehension and oral communication skills through interactive exercises, video content, and guided conversations.',
    color: '#FF6F00',
  },
  {
    id: 'b',
    titleZh: '阅读',
    titleEn: 'Reading & Comprehension',
    image: process.env.PUBLIC_URL + '/images/reading.jpeg',
    description: 'Build solid reading foundations with exam-style training, comprehension analysis, and practice on various text types.',
    color: '#26A69A',
  },
  {
    id: 'c',
    titleZh: '写作',
    titleEn: 'Writing & Composition',
    image: process.env.PUBLIC_URL + '/images/writing.jpeg',
    description: 'Master Chinese writing from basic phrases to full compositions, including idioms, proverbs, picture composition, and essay writing.',
    color: '#7B1FA2',
  },
  {
    id: 'd',
    titleZh: 'PSLE训练',
    titleEn: 'PSLE Intensive',
    image: process.env.PUBLIC_URL + '/images/psle.png',
    description: 'Targeted PSLE preparation with real past-year papers and exam techniques to boost confidence and results.',
    color: '#E53935',
  },
];

export const courseDetails = [
  {
    id: 'a',
    content: [
      { zh: '听力', en: 'Listening' },
      { zh: '口试', en: 'Oral Examination' },
      { zh: '朗读', en: 'Reading Aloud' },
      { zh: '视频', en: 'Videos' },
      { zh: '会话', en: 'Conversations' },
    ],
  },
  {
    id: 'b',
    content: [
      { zh: '试卷题型训练', en: 'Exam Paper Skills Training' },
      { zh: '基础知识练习', en: 'Basic Knowledge Practice' },
      { zh: '便条', en: 'Notes' },
      { zh: '阅读理解分析', en: 'Reading Comprehension Analysis' },
    ],
  },
  {
    id: 'c',
    content: [
      { zh: '写作', en: 'Writing' },
      { zh: '开头结尾', en: 'Introductions and Conclusions' },
      { zh: '好词好句好段', en: 'Phrases and Paragraphs' },
      { zh: '成语', en: 'Idioms' },
      { zh: '俗语', en: 'Proverbs' },
      { zh: '看图作文', en: 'Picture Composition' },
      { zh: '命题作文', en: 'Composition Writing' },
      { zh: '完成文章', en: 'Completing Articles' },
    ],
  },
  {
    id: 'd',
    content: [
      { zh: 'PSLE真题训练', en: 'PSLE Past Paper Training' },
    ],
  },
];
